import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { post } from "../../../shared/data";
import { EMPTY_PAGINATION } from "../../../shared/constants";
import { format } from "date-fns";

export const getNewFilterParams = (filters) => {
    return filters.reduce((arr, filter) => {
        const mapContains = (name, value) => {
            arr.push({ column: name, value: `${value.trim()}`, operator: "LIKE" });
        };

        const mapListItem = (name, values) => {
            arr.push({ column: name, values: values, operator: "INLIKE" });
        };

        const mapEquals = (name, value) => {
            arr.push({ column: name, value: decodeURI(value.trim()), operator: "EQ" });
        };

        const mapGreaterThan = (name, value) => {
            arr.push({ column: name, value: decodeURI(value.trim()), operator: "GTE" });
        };

        const mapLessThan = (name, value) => {
            arr.push({ column: name, value: decodeURI(value.trim()), operator: "LTE" });
        };

        const id = filter.id.split(".").shift();

        switch (id) {
            case "startDate":
                if (filter.value.filterFromDate) {
                    const fromMoment = format(new Date(filter.value.filterFromDate), DATE_FNS_SHORT_DATE_FORMAT);
                    mapGreaterThan(id, fromMoment);
                }

                if (filter.value.filterToDate) {
                    const toMoment = format(new Date(filter.value.filterToDate), DATE_FNS_SHORT_DATE_FORMAT);
                    mapLessThan(id, toMoment);
                }

                break;

            case "exactDate":
                arr.push({ column: "startDate", value: filter.value.replace("/", "-"), operator: "LIKE" });
                break;

            case "shipmentType":
                if (filter.value !== "-1") {
                    mapEquals(id, filter.value);
                }

                break;
            case "carrier":
                mapContains("carrierName", filter.value);

                break;
            case "receivedBy":
                mapContains("receivedByName", filter.value);

                break;
            case "client":
                mapContains("clientName", filter.value);

                break;
            case "packageLevelName":
                mapContains(id, filter.value);

                break;
            case "cxHClient":
                mapContains("cxHClientName", filter.value);
                break;
            case "supplier":
                mapContains("supplierName", filter.value);
                break;

            case "isRush":
                if (filter.value !== "all") {
                    mapEquals(id, filter.value);
                }

                break;
            case "upcs":
                if (filter.values) {
                    mapListItem(id, filter.values);
                }

                break;
            case "locationDataSource":
                if (filter.value !== "") {
                    mapEquals(id, filter.value);
                }

                break;
            default:
                mapContains(id, filter.value);
                break;
        }

        return arr;
    }, []);
};

export const filterShipments = (pageNumber = 1, pageSize = 10, sorted = [], filter = []) => {
    const filterBy = getNewFilterParams(filter);

    if (sorted.length < 0 || sorted[0].id !== "hasMeasuringRedoTask") {
        sorted.unshift({ id: "hasMeasuringRedoTask", desc: true });
    }

    return post(
        "/receiving/shipments/search",
        {
            PagingInfo: {
                PageSize: pageSize,
                PageNumber: pageNumber,
            },
            sortColumns: sorted
                .filter(({ desc }) => typeof desc === "boolean")
                .map(({ id, desc }) => {
                    if (id === "exactDate") {
                        id = "startDate";
                    }

                    return {
                        columnName: id,
                        sortOrder: desc ? "desc" : "asc",
                    };
                }),

            Filters: filterBy,
        },
        { defaultReturn: { ...EMPTY_PAGINATION } }
    );
};

export const buildDefaultShipmentData = () => {
    return {
        dueDate: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
        isLoaded: false,
        sla_counts: {},
        locationValue: "",
        carrier: "",
        carrierTrackingNumbers: [],
        client: "",
        cxHCompany: "",
        createdBy: "",
        createdOn: "",
        dueOn: "",
        finalDestination: "",
        finalDestinationContact: "",
        hasMetricMeasurementsOnly: false,
        hasPremiumEditingShipmentDefault: false,
        holdReleaseDate: "",
        holdReleasedOnDate: null,
        imagesNeedClientApprovalDefault: false,
        isCmp: false,
        isCmpConfirmed: false,
        isCompleted: false,
        isMasterDataSolution: false,
        isMissingPaperwork: false,
        isMissingPayment: false,
        isMissingReturnDate: false,
        isOnHold: false,
        isPerishable: false,
        isRush: false,
        key: "",
        legacyItemMasterShipmentTypeId: "",
        paymentMethod: "",
        paymentReferenceNumber: "",
        receivedBy: "",
        receivedOn: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
        startDate: format(new Date(), DATE_FNS_SHORT_DATE_FORMAT),
        rushDays: "",
        rushConfirmedBy: "",
        supplier: "",
        turnAroundDays: "",
        updatedBy: "",
        updatedOn: "",
        showInactiveClients: false,
    };
};
